<template lang="pug">
  b.col.ov_with_ot(cols="2")
    div
      <font-awesome-icon :icon="['fa', 'laptop']" />
      span.title.ml-2 Datos de falla

    b-row.mt-4( class="align-items-center")
      b-col(cols="12")
        span.subtitle_repuesto Reporte de la falla
        span.comentarios {{ item.datos_falla_ot_asociada ? item.datos_falla_ot_asociada.reporte_falla : '' }}
      b-col.mt-3(cols="12")
        span.subtitle_repuesto Diagnóstico
        span.comentarios {{ item.datos_falla_ot_asociada ? item.datos_falla_ot_asociada.diagnostico : '' }}

    div.mt-4
      <font-awesome-icon :icon="['fa', 'laptop']" />
      span.title.ml-2 Datos del equipo

    b-row.mt-4( class="align-items-center")
      b-col(cols="12")
        span.subtitle_repuesto Nº de Serie
        span.comentarios {{ item.numero_serie_equipo }}
      b-col.mt-3(cols="12")
        span.subtitle_repuesto Marca
        span.comentarios {{ item.datos_equipo ? item.datos_equipo.marca : '' }}
      b-col.mt-3(cols="12")
        span.subtitle_repuesto Modelo
        span.comentarios {{ item.datos_equipo ? item.datos_equipo.modelo : '' }}

    div.mt-4
      <font-awesome-icon :icon="['fa', 'address-book']" />
      span.title.ml-2 Datos del cliente

    b-row.mt-4( class="align-items-center")
      b-col(cols="12")
        span.subtitle_repuesto Nombre
        span.comentarios {{ item.nombre }}
      b-col.mt-3(cols="12")
        span.subtitle_repuesto RUT
        span.comentarios {{ item.rut }}
      b-col.mt-3(cols="12")
        span.subtitle_repuesto Correo
        span.comentarios {{ item.correo_electronico }}
      b-col.mt-3(cols="12")
        span.subtitle_repuesto Teléfono
        span.comentarios {{ item.telefono }}
      b-col.mt-3(cols="12")
        span.subtitle_repuesto Dirección
        span.comentarios {{ item.direccion }}

</template>

<script>
export default {
  name: 'OVwithOTData',
  props: {
    item: {
      type: Object,
      required: false
    }

  }
}

</script>
